import { desktopMenu } from "./desktopMenu";
import { mobileMenu } from "./mobileMenu";
import { scrollEffect } from "./scrollEffect";

export const menu = () => {
  mobileMenu();
  desktopMenu();
  scrollEffect();
};
